import request from '@/utils/request'

export function getChannelList(params) {
  return request({
    url: 'notice/channel',
    method: 'get',
    params
  })
}

export function getSingleChannel(id) {
  return request({
    url: 'notice/channel/' + id,
    method: 'get'
  })
}

export function createChannel(id, data) {
  return request({
    url: 'notice/channel',
    method: 'post',
    data
  })
}

export function testChannel(data) {
  return request({
    url: 'notice/channel/test',
    method: 'post',
    data
  })
}

export function updateChannel(id, data) {
  return request({
    url: 'notice/channel/' + id,
    method: 'put',
    data
  })
}

export function deleteChannel(data) {
  return request({
    url: 'notice/channel/' + data,
    method: 'delete'
  })
}

/** 复制通知通道 */
export function noticeChannelCopy(id) {
  return request({
    url: `/notice/channel/${id}/copy`,
    method: 'post'
  })
}
